module.exports = __webpack_public_path__ + "img/report.73a0eb19.png";